import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { IconButton, Tooltip } from "@material-ui/core";
import { Visibility as ViewIcon } from "@material-ui/icons";
import {
  withModulesManager,
  withHistory,
  formatMessage,
  formatMessageWithValues,
  formatDateFromISO,
  Searcher,
} from "@openimis/fe-core";
import { fetchPolicyHolderEnrollmentBatches } from "../actions";
import EnrollmentFilter from "./EnrollmentFilter";
import EnrollmentStatusBadge from "./common/EnrollmentStatusBadge";
import {
  DEFAULT_ENROLLMENT_FILTERS,
  DEFAULT_PAGE_SIZE,
  ROWS_PER_PAGE_OPTIONS,
} from "../constants";
import { filtersToQueryParams, enrollmentRowIdentifier } from "../utils/searcher";
import { formatDisplayValue } from "../utils/enrollmentData";

class PolicyHolderEnrollmentBatchSearcher extends Component {
  constructor(props) {
    super(props);
    this.rowsPerPageOptions = props.modulesManager.getConf(
      "fe-enrollment",
      "policyHolderBatchFilter.rowsPerPageOptions",
      ROWS_PER_PAGE_OPTIONS
    );
    this.defaultPageSize = props.modulesManager.getConf(
      "fe-enrollment",
      "policyHolderBatchFilter.defaultPageSize",
      DEFAULT_PAGE_SIZE
    );
  }

  fetch = (prms) => {
    this.props.fetchPolicyHolderEnrollmentBatches(this.props.modulesManager, prms);
  };

  headers = () => [
    "policyHolderBatch.policyHolder",
    "policyHolderBatch.code",
    "policyHolderBatch.employeeCount",
    "policyHolderBatch.status",
    "policyHolderBatch.enrollmentDate",
    "",
  ];

  sorts = () => [
    null,
    null,
    null,
    ["status", true],
    ["dateCreated", false],
    null,
  ];

  itemFormatters = () => {
    const { modulesManager, intl, onDoubleClick } = this.props;
    return [
      (e) =>
        formatDisplayValue(
          e.policyHolder?.tradeName ||
            e.policyholderEnrollment?.uuid ||
            e.uuid
        ),
      (e) => formatDisplayValue(e.policyHolder?.code),
      (e) => formatDisplayValue(e.employeeCount ?? 0),
      (e) => <EnrollmentStatusBadge status={e.status || "DRAFT"} size="small" />,
      (e) => formatDateFromISO(modulesManager, intl, e.dateCreated) || "-",
      (e) => (
        <Tooltip title={formatMessage(intl, "enrollment", "general.view") || "View"}>
          <IconButton
            size="small"
            onClick={(ev) => {
              ev.stopPropagation();
              onDoubleClick && onDoubleClick(e);
            }}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    ];
  };

  render() {
    const {
      intl,
      policyHolderBatches,
      policyHolderBatchesPageInfo,
      fetchingPolicyHolderBatches,
      fetchedPolicyHolderBatches,
      errorPolicyHolderBatches,
      cacheFiltersKey,
      onDoubleClick,
    } = this.props;

    const totalCount =
      policyHolderBatchesPageInfo?.totalCount ??
      policyHolderBatches?.length ??
      0;

    return (
      <Fragment>
        <Searcher
          module="enrollment"
          cacheFiltersKey={cacheFiltersKey}
          FilterPane={EnrollmentFilter}
          items={policyHolderBatches}
          itemsPageInfo={{
            ...policyHolderBatchesPageInfo,
            totalCount,
          }}
          fetchingItems={fetchingPolicyHolderBatches}
          fetchedItems={fetchedPolicyHolderBatches}
          errorItems={errorPolicyHolderBatches}
          tableTitle={formatMessageWithValues(
            intl,
            "enrollment",
            "policyHolderBatch.searcher.results",
            { count: totalCount.toLocaleString() }
          )}
          rowsPerPageOptions={this.rowsPerPageOptions}
          defaultPageSize={this.defaultPageSize}
          defaultFilters={DEFAULT_ENROLLMENT_FILTERS}
          defaultOrderBy="-dateCreated"
          fetch={this.fetch}
          rowIdentifier={enrollmentRowIdentifier}
          filtersToQueryParams={filtersToQueryParams}
          headers={this.headers}
          itemFormatters={this.itemFormatters}
          sorts={this.sorts}
          onDoubleClick={(i) => onDoubleClick && onDoubleClick(i)}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  policyHolderBatches: state.enrollment?.policyHolderBatches || [],
  policyHolderBatchesPageInfo:
    state.enrollment?.policyHolderBatchesPageInfo || {},
  fetchingPolicyHolderBatches: state.enrollment?.fetchingPolicyHolderBatches,
  fetchedPolicyHolderBatches: state.enrollment?.fetchedPolicyHolderBatches,
  errorPolicyHolderBatches: state.enrollment?.errorPolicyHolderBatches,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchPolicyHolderEnrollmentBatches }, dispatch);

export default withModulesManager(
  withHistory(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(injectIntl(PolicyHolderEnrollmentBatchSearcher))
  )
);
